export enum ModuleTemplateTypeEnum {
  userGuide = "userGuide",
  getContent = "getContent",
  systemInput = "systemInput",
  flowControl = "flowControl",
  tools = "tools",
  textAnswer = "textAnswer",
  functionCall = "functionCall",
  logicDeal = "logicDeal",
  externalCall = "externalCall",

  output = "output",

  other = "other",

  // AI机器人调用
  appCall = "appCall",
  // 子流程插件
  pluginCall = "pluginCall",
  // 企业微信分类
  enterpriseWeChat = "enterpriseWeChat",
  // 雀鲷分类
  damselfish = "damselfish",
}

/**
 * 是否是复合节点
 * @param templateType
 * @returns
 */
export const isComposeNode = (templateType: ModuleTemplateTypeEnum) => {
  return [
    ModuleTemplateTypeEnum.appCall,
    ModuleTemplateTypeEnum.pluginCall,
  ].includes(templateType);
};

/**
 * 是否为特殊渠道节点
 * @param templateType
 * @returns
 */
export const isChannelNode = (templateType: ModuleTemplateTypeEnum) => {
  return [
    ModuleTemplateTypeEnum.enterpriseWeChat,
    ModuleTemplateTypeEnum.damselfish,
  ].includes(templateType);
};

export enum ModuleIOValueTypeEnum {
  string = "string",
  number = "number",
  boolean = "bool",
  chatHistory = "chatHistory",
  datasetQuote = "datasetQuote",
  map = "map",
  any = "any",

  tools = "tools",

  numberCompare = "numberCompare",

  fieldDescription = "fieldDescription",
  kv = "kv",

  // 给AI机器人嵌入调用用的字符串数组结果
  stringArray = "stringArray",

  // 选择MCP
  mcpSetting = "mcpSetting",
}

export enum ModuleInputKeyEnum {
  // old
  welcomeText = "welcomeText",
  variables = "variables",
  switch = "switch", // a trigger switch
  chatHistory = "chatHistory",
  userChatInput = "userChatInput",

  tts = "tts",
  answer = "answer",
  agents = "agents", // cq agent key

  // edit
  addTemplate = "addTemplate",
  template = "template",

  // latest
  // common
  aiModel = "aiModel",
  aiSystemPrompt = "systemPrompt",
  description = "description",
  anyInput = "system_anyInput",
  textareaInput = "system_textareaInput",
  addInputParam = "system_addInputParam",

  // ai chat
  aiChatTemperature = "aiChatTemperature",
  aiChatMaxToken = "maxToken",
  aiChatSettingModal = "aiSettings",
  aiChatIsResponseText = "isResponseAnswerText",
  aiChatQuoteTemplate = "quoteTemplate",
  aiChatQuotePrompt = "quotePrompt",
  knowledges = "knowledges",

  // tfJudge
  tfJudgeValue = "tfJudgeValue",
  tfJudgeMode = "tfJudgeMode",
  tfJudgeOpNum = "tfJudgeOpNum",
  tfJudgePattern = "tfJudgePattern",

  // 知识库
  knowledgeSelectList = "selectedList",
  knowledgeSimilarity = "similarity",
  knowledgeMaxRows = "maxRows",
  knowledgeMaxTokens = "maxTokens",
  knowledgeSearchMode = "searchMode",

  // 内容提取
  contextExtractInput = "extractInput",
  contentExtractMode = "extractMode",
  contentExtractTypes = "extractTypes",
  contentExtractKeys = "extractKeys",
  contentExtractRegexp = "extractRegexp",

  // http请求
  httpReqUrl = "httpReqUrl",
  httpHeaders = "httpHeaders",
  httpMethod = "httpMethod",
  httpParams = "httpParams",
  httpBody = "httpBody",

  // 聊天记录获取
  chatId = "chatId",
  chatHistoryUrl = "chatHistoryUrl",
  chatMsgCount = "chatMsgCount",

  // 获取自定义属性
  attributes = "attributes",

  wxworkTags = "wxworkTags",

  // 消息切分方式
  messageCuttingType = "messageCuttingType",
  messageCuttingSeparator = "messageCuttingSeparator",

  // 定义AI机器人调用和子流程调用的输入
  selectApp = "selectApp", // 调用 App
  selectPlugin = "selectPlugin", // 调用 Plugin
  invokeAppQuestion = "invokeAppQuestion", // 调用 App 问题
  pythonCode = "pythonCode",
}

export enum ModuleOutputKeyEnum {
  // common
  responseData = "responseData",
  moduleDispatchBills = "moduleDispatchBills",
  userChatInput = "userChatInput",
  finish = "finish",
  history = "history",
  aiAnswer = "aiAnswer", //  answer module text key

  text = "text",
  addOutputParam = "addOutputParam",

  // 对话记录获取
  chatHistory = "chatHistory",

  // 知识库搜索
  knowledgeIsEmpty = "empty",
  knowledgeUnEmpty = "unEmpty",
  knowledgeResults = "results",

  // 内容提取
  contextExtractResults = "extractResults",
  contextExtractSuccess = "extractSuccess",
  contextExtractFail = "extractFail",

  // 判断器
  resultTrue = "resultTrue",
  resultFalse = "resultFalse",

  // http
  httpRawResponse = "httpRawResponse",
  httpOkResponse = "httpOkResponse",
  httpFailedResponse = "httpFailedResponse",

  // tools
  selectedTools = "selectedTools",

  attributes = "attributes",

  contentEditResult = "result",
  wxworkTags = "wxworkTags",

  // AI机器人嵌入回答
  invokeAppAnswer = "invokeAppAnswer",
}

export enum VariableInputEnum {
  input = "input",
  textarea = "textarea",
  select = "select",
  external = "external",
}

export const DYNAMIC_INPUT_KEY = "DYNAMIC_INPUT_KEY";

/* ------------ search -------------- */
export enum DatasetSearchModeEnum {
  embedding = "embedding",
  fullTextRecall = "fullTextRecall",
  mixedRecall = "mixedRecall",
}

export enum LLMModelTypeEnum {
  all = "all",
  classify = "classify",
  extractFields = "extractFields",
  toolCall = "toolCall",
  queryExtension = "queryExtension",
}
export const llmModelTypeFilterMap = {
  [LLMModelTypeEnum.all]: "model",
  [LLMModelTypeEnum.classify]: "usedInClassify",
  [LLMModelTypeEnum.extractFields]: "usedInExtractFields",
  [LLMModelTypeEnum.toolCall]: "usedInToolCall",
  [LLMModelTypeEnum.queryExtension]: "usedInQueryExtension",
};
